import React, { useEffect } from "react";
import Header from "../../components/ui/Header";
import ContactHero from "./components/ContactHero";
import ContactMethods from "./components/ContactMethods";
import ConsultationBooking from "./components/ConsultationBooking";
import ContactForm from "./components/ContactForm";
// import StudioLocation from './components/StudioLocation';
import SocialConnect from "./components/SocialConnect";
import Icon from "../../components/AppIcon";

const ContactSchedulingHub = () => {
  useEffect(() => {
    // Set page title
    document.title = "Contact & Scheduling Hub - Skycrest Studios";

    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription?.setAttribute(
        "content",
        "Connect with Skycrest Studios through multiple channels. Book consultations or start your video production project today. Award-winning team ready to bring your vision to life."
      );
    }

    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="relative">
        {/* Hero Section */}
        <ContactHero />

        {/* Contact Methods */}
        <ContactMethods />

        {/* Consultation Booking */}
        <ConsultationBooking />

        {/* Contact Form */}
        <ContactForm />

        {/* Studio Location removed */}

        {/* Social Connect */}
        <SocialConnect />
      </main>
      {/* Footer */}
      <footer className="bg-primary text-primary-foreground py-12">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="relative">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 40 40"
                    className="text-primary-foreground"
                    fill="currentColor"
                  >
                    <path
                      d="M20 2L35 12v16L20 38L5 28V12L20 2z"
                      opacity="0.1"
                    />
                    <path
                      d="M20 6L31 14v12L20 34L9 26V14L20 6z"
                      opacity="0.3"
                    />
                    <path d="M20 10L27 16v8L20 30L13 24v-8L20 10z" />
                    <circle cx="20" cy="20" r="3" fill="var(--color-accent)" />
                  </svg>
                </div>
                <div>
                  <span className="text-lg font-bold font-display">
                    Skycrest
                  </span>
                  <span className="block text-xs font-medium tracking-wider opacity-80">
                    STUDIOS
                  </span>
                </div>
              </div>
              <p className="text-sm opacity-80 mb-4">
                Crafting visual experiences that elevate brands and capture
                life's most precious moments with cinematic excellence.
              </p>
              <div className="flex space-x-3">
                <button className="w-8 h-8 bg-primary-foreground/10 rounded-full flex items-center justify-center hover:bg-primary-foreground/20 transition-fast">
                  <Icon name="Instagram" size={16} />
                </button>
                <button className="w-8 h-8 bg-primary-foreground/10 rounded-full flex items-center justify-center hover:bg-primary-foreground/20 transition-fast">
                  <Icon name="Youtube" size={16} />
                </button>
                <button className="w-8 h-8 bg-primary-foreground/10 rounded-full flex items-center justify-center hover:bg-primary-foreground/20 transition-fast">
                  <Icon name="Linkedin" size={16} />
                </button>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm opacity-80">
                <li>
                  <a
                    href="/adaptive-homepage-hub"
                    className="hover:opacity-100 transition-fast"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="/dynamic-portfolio-ecosystem"
                    className="hover:opacity-100 transition-fast"
                  >
                    Portfolio
                  </a>
                </li>
                <li>
                  <a
                    href="/services-architecture-hub"
                    className="hover:opacity-100 transition-fast"
                  >
                    Services
                  </a>
                </li>
                <li>
                  <a
                    href="/case-studies-showcase"
                    className="hover:opacity-100 transition-fast"
                  >
                    Case Studies
                  </a>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="font-semibold mb-4">Services</h4>
              <ul className="space-y-2 text-sm opacity-80">
                <li>
                  <span className="hover:opacity-100 transition-fast">
                    Wedding Videography
                  </span>
                </li>
                <li>
                  <span className="hover:opacity-100 transition-fast">
                    Real Estate Marketing
                  </span>
                </li>
                <li>
                  <span className="hover:opacity-100 transition-fast">
                    Brand Content
                  </span>
                </li>
                <li>
                  <span className="hover:opacity-100 transition-fast">
                    Design Fiction
                  </span>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-semibold mb-4">Contact</h4>
              <div className="space-y-2 text-sm opacity-80">
                <p>Rockport, MA 01966</p>
                <p>(508) 980-5187</p>
                <p>hello@skycreststudios.com</p>
              </div>
            </div>
          </div>

          <div className="border-t border-primary-foreground/20 mt-8 pt-8 flex flex-col md:flex-row items-center justify-between text-sm opacity-80">
            <p>
              &copy; {new Date()?.getFullYear()} Skycrest Studios. All rights
              reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="hover:opacity-100 transition-fast">
                Privacy Policy
              </a>
              <a href="#" className="hover:opacity-100 transition-fast">
                Terms of Service
              </a>
              <a href="#" className="hover:opacity-100 transition-fast">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactSchedulingHub;
